const PropTypes = require('prop-types');
const React = require('react');
const ReactDOM = require('react-dom');
const classnames = require('classnames');

// @components
const { Button } = require('commonsComponents/button');
const { relatedTarget } = require('utilities/browserUtils');

// @constants
const { KEYBOARD_ESC } = require('constants/index');
import { ES_LANG } from 'constants/contactCenter/language';
const { getLanguage } = require('core/i18n').i18n;

class DropdownLang extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            position: 'bottom'
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleClickLang = this.handleClickLang.bind(this);
    }

    buildLinks(items) {
        const currentLanguage = getLanguage()
        return items.map( (item, index) => {
            let icon, subItems;
            const dropdownListClassNames = classnames('dropdown__list', {
                'dropdown__list--selected': (!currentLanguage && item.hreflang === ES_LANG) || (currentLanguage && currentLanguage === item.hreflang)
            });

            if (item.icon) {
                const iconClassName = classnames('icon', item.icon);
                icon = <i className={iconClassName}/>;
            }

            if (item.subitems) {
                subItems = this.buildSubLinks(item.subitems);
            }

            return (
                <li
                    key={index}
                    className={dropdownListClassNames}
                    onClick={() => { this.handleClickLang(item.hreflang)}}
                >
                    <a className="dropdown__link" href="">
                        {icon}
                        {item.label}
                    </a>
                    {subItems}
                </li>
            );
        });
    }

    handleClickLang(language) {
        const localLanguageKey = `ccAgentLanguage`;
        const currentLanguage = localStorage.getItem(localLanguageKey);
        if (currentLanguage !== language) {
            localStorage.setItem(localLanguageKey, language);
            // Test if set has worked properly and reload if ok
            if (localStorage.getItem(localLanguageKey) === language) {
                location.reload();
            }
        }
    }

    calculatePosition() {
        const component = ReactDOM.findDOMNode(this);
        const menu = component.querySelector('.dropdown__menu');
        const menuHeight = menu.getBoundingClientRect().height;
        const componentBottom = component.getBoundingClientRect().bottom;
        const documentHeight = document.body.getBoundingClientRect().height;

        if ((documentHeight - componentBottom) < menuHeight) {
            return 'top';
        } else {
            return 'bottom';
        }
    }

    handleBlur(evt) {
        const target = relatedTarget(evt);
        const targetIsLink = target ? target.classList.contains('dropdown__link') : false;

        if (this.state.open && !targetIsLink) {
            this.toggleDropdown();
        }
    }

    handleClick(evt) {
        evt.stopPropagation();

        this.setState({
            position: this.calculatePosition()
        });

        this.toggleDropdown();
    }

    handleKeyDown(evt) {
        switch (evt.keyCode) {
            case KEYBOARD_ESC:
                if (this.state.open) {
                    this.toggleDropdown();
                }
                break;
        }
    }

    toggleDropdown() {
        this.setState(currentState => {
            return {
                open: !currentState.open
            };
        }, () => {
            this.props.onStateChange({open: this.state.open});
        });
    }

    render() {
        const { iconClass, buttonClass, items, id, className, withArrow, modifier, children } = this.props;
        const { open, position } = this.state;
        const classes = classnames(
            'dropdown',
            {
                'open' : open,
                [className]: !!className
            }
        );
        const buttonProperties = {
            extraClass: buttonClass,
            iconClass,
            id,
            dataToggle: 'dropdown',
            children: children,
            modifier
        };
        const itemsClassName = classnames(
            'dropdown__menu dropdown-menu',
            `dropdown__menu--${position}`,
            {
                'dropdown__menu--without-arrow': !withArrow
            }
        );

        return (
            <div
                className={classes}
                onClick={this.handleClick}
                onBlur={this.handleBlur}
                onKeyDown={this.handleKeyDown}>
                <Button {...buttonProperties}>
                    {buttonProperties.children}
                </Button>
                <ul
                    className={itemsClassName}
                    aria-labelledby={id}>
                    {this.buildLinks(items)}
                </ul>
            </div>
        );
    }
}

DropdownLang.propTypes = {
    items: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    children: PropTypes.any,
    iconClass: PropTypes.string,
    buttonClass: PropTypes.string,
    className: PropTypes.string,
    withArrow: PropTypes.bool,
    modifier: PropTypes.string,
    onStateChange: PropTypes.func,
};

DropdownLang.defaultProps = {
    buttonClass: '',
    withArrow: true,
    onStateChange: function(){}
};

export { DropdownLang };
